// See iu-root-config.ts for why we need a relative import
/* eslint-disable-next-line import/no-relative-packages */
import { MondrianInstance } from '../../../config';

const LEGACY_PATHS = ['/local/', '/course/', '/mod/', '/my'] as const;

/**
 * Redirects legacy-like paths to the myCampusClassic Moodle instance on LIBF only.
 *
 * @param instance - The current instance.
 */
export function legacyRedirect(instance: MondrianInstance): boolean {
  if (instance.id !== 'LIBF') {
    return false;
  }

  const { pathname, search } = window.location;

  if (LEGACY_PATHS.some((path) => pathname.startsWith(path))) {
    window.location.replace(`${instance.moodleBaseUrl}${pathname}${search}`);
    return true;
  }
  return false;
}
